module.exports = __webpack_public_path__ + "static/img/industry-dx.37e59754.png";